import type { ClipboardEvent } from "react";

export const preventNonNumericInputPaste = (
  e: ClipboardEvent<HTMLElement>,
  noDecimals?: boolean,
) => {
  const value = e.clipboardData.getData("Text");
  const invalidSymbols = ["e", "E", "-", "+"];

  if (noDecimals) {
    invalidSymbols.push(".", ",");
  }

  const hasInvalidSymbols = invalidSymbols.some((symbol) =>
    value.includes(symbol),
  );

  if (hasInvalidSymbols) {
    e.preventDefault();
  }
};
